export class MedicalEducation {
    constructor() {
        this.isGraduationYearValid = true;
        this.isLocationIdValid = true;
    }
    public medicalEducationId: number;
    public physicianId: number;
    public graduationYear: number;
    public locationId: number;
    public isGraduationYearValid: boolean;
    public isLocationIdValid: boolean;
}